import { useEffect, useState } from 'react';
// LaTeX
import Latex from 'react-latex-next'
// mui components
import { Alert, Button, FormGroup, TextField } from '@mui/material'
// mathjs
import { parse } from "mathjs";
// selectores
import { comparePoints } from '../../../../../selectors/Punto';
import { isPoint } from '../../../../../selectors/Punto/functions';

type Props = {
  estado: boolean | undefined
  handleRespuestaUsuario: Function
  respuesta: string
}

type State = {
  ok: null | Boolean
  title: string
  msg: string
}

const FormularioPunto = ({ estado, handleRespuestaUsuario, respuesta }: Props) => {

  const [respuestaUsuario, setRespuestaUsuario] = useState('');

  const [toTex, setToTex] = useState('');
  const [error, setError] = useState(false);
  const [onFocus, setOnFocus] = useState(false);

  const [alert, setAlert] = useState(false);

  const [state, setState] = useState<State>({
    ok: null,
    title: '',
    msg: ''
  });

  useEffect(() => {
    if (alert) {
      const timer = setTimeout(() => { setAlert(false); }, 5000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  useEffect(() => {
    if (respuestaUsuario === '') {
      setToTex('');
      return setError(false);
    }

    const customLaTeX = {
      'intervaloUno': function (node: any, options: any) { //override toTex for builtin functions
        const array = []
        for (let k = 0; k < node.args.length; k++) {
          const element = node.args[k].toTex(options);
          array.push(element)
        }
        return '\\left(' + array.join() + '\\right)'
      }
    }

    if (isPoint(respuestaUsuario).ok) {

      const respuestaUsuarioClean = respuestaUsuario.replace(/ /g, '');

      try {
        const ntupla = respuestaUsuarioClean.substring(1, respuestaUsuarioClean.length - 1);
        const vector = `intervaloUno(${ntupla})`
        const toTex = parse(vector).toTex({ handler: customLaTeX })
        setToTex(`\\[${toTex}\\]`);
        setError(false);
      } catch (error) {
        setToTex(respuestaUsuario);
        setError(true);
      }
    } else {
      setToTex(respuestaUsuario);
      setError(true);
    }
  }, [respuestaUsuario]);

  const handleRespuesta = () => {
    if (respuestaUsuario !== '') {
      setAlert(true);
      setState(comparePoints(respuesta, respuestaUsuario));
      setOnFocus(false)
      handleRespuestaUsuario(comparePoints(respuesta, respuestaUsuario))
    }
  }

  return (
    <div className='card-footer'>

      <div className="row justify-content-between align-items-center my-2">
        <div className="col-auto p-0">
          <FormGroup sx={{ py: 0 }} row>
            <TextField
              type='text'
              sx={{ minWidth: 200 }}
              label="Ingrese un punto"
              variant="outlined"
              size="small"
              autoComplete='off'
              value={respuestaUsuario}
              onChange={(e) => setRespuestaUsuario(e.target.value)}
              onFocus={() => setOnFocus(true)}
              disabled={estado !== undefined}
            />
            <Button
              sx={{ mx: 1 }}
              size="small"
              color="primary"
              variant="outlined"
              onClick={handleRespuesta}
              aria-label="close"
              disabled={alert || respuestaUsuario === '' || estado !== undefined}
            >
              Revisar
            </Button>
          </FormGroup>
        </div>
        <div className="col-auto">
          {/* <Menu tipo={tipo} /> */}
        </div>

      </div>

      {
        onFocus &&
        <div className="row justify-content-center align-items-center mt-3 mb-2">
          <div className="col-12" style={{ backgroundColor: 'white', minHeight: '5em', border: 'solid #808080 1px', borderRadius: '5px' }}>
            <div style={{ color: error ? 'red' : '', backgroundColor: 'white' }} className="text-center">
              <Latex>{toTex}</Latex>
            </div>
          </div>
        </div>
      }

      {
        alert &&
        <Alert
          severity={state.ok === null ? 'info' : (state.ok ? 'success' : 'error')}
          sx={{ position: 'relative', mt: 1 }}
        >
          {state.title} {state.msg}
        </Alert>
      }
    </div>

  )
}

export default FormularioPunto;